const faqItems = [
  {
    id: 1,
    title: 'landingPage.faq.question1.question',
    content: 'landingPage.faq.question1.answer',
  },
  {
    id: 2,
    title: 'landingPage.faq.question2.question',
    content: 'landingPage.faq.question2.answer',
  },
  {
    id: 3,
    title: 'landingPage.faq.question3.question',
    content: 'landingPage.faq.question3.answer',
  },
  {
    id: 4,
    title: 'landingPage.faq.question4.question',
    content: 'landingPage.faq.question4.answer',
  },
  {
    id: 5,
    title: 'landingPage.faq.question5.question',
    content: 'landingPage.faq.question5.answer',
  },
];

export default faqItems;
